import { getConf } from "@configuratorware/configurator-frontendgui/App/configuration";
import { useMediaQuery, useTheme } from "@material-ui/core";
import { useSelector } from "react-redux";
import React, { useEffect, useState } from "react";
import { get } from "lodash";
import { CreatorScreen } from "@configuratorware/configurator-frontendgui/App/Modules/Creator/CreatorScreen";
import OptionsListContainer from "@configuratorware/configurator-frontendgui/App/Modules/Creator/Containers/OptionsList";
import { Services } from "@configuratorware/configurator-frontendgui/App/ServiceLocator";

export default (props) => {
    // to show productsPartList in vertical model when not in mobile view
    const dock = getConf("dock");
    const theme = useTheme();
    const isMobileScreen = useMediaQuery(theme.breakpoints.down("xs"));
    const vertical = dock ? dock === "left" : !isMobileScreen;

    const loadCode = useSelector((state) =>
        get(state, "configurator.loadCode", null)
    );
    const status = useSelector((state) =>
        get(state, "configurator.configuration.status", null)
    );
    const loadedFromList = useSelector((state) =>
        get(state, "basket.configurationFromList", false)
    );
    const [restrictConfiguration, setRestrictConfiguration] = useState(false);
    useEffect(() => {
        if (
            loadCode &&
            status &&
            (status === "reorderable" || status === "inactive")
        ) {
            setRestrictConfiguration(true);
            Services.designData.toggleHighlight(false);
            if (loadedFromList) {
                setRestrictConfiguration(false);
            }
        }
    }, [status]);
    const renderOptionsList = (props) => {
        return <OptionsListContainer {...props} selectOption={() => {}} />;
    };
    return (
        <div>
            <CreatorScreen
                {...props}
                renderOptionsList={restrictConfiguration ? renderOptionsList : props.renderOptionsList}
                vertical={vertical}
            />
    </div>
);
};